import React, { useState, useEffect } from 'react';
import { getServicios, saveServicio, deleteServicio } from '../../services/ProductService';

// Estilos
import '../static/Global.css';
import '../static/Home.css';
import '../static/Aside.css';
import '../static/Flotante.css';
import '../static/Busqueda.css';

function DashboardProductos() {
    const [servicios, setServicios] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        servicios_id: '',
        nombre: '',
        descripcion: '',
        imagen: '',
        visibilidad: 'visible'
    });

    useEffect(() => {
        cargarLista();
    }, []);

    const cargarLista = async () => {
        try {
            setLoading(true);
            // Traemos todos los servicios (incluyendo ocultos para administración)
            const data = await getServicios({ all: 'true' });
            setServicios(Array.isArray(data) ? data : []);
            setLoading(false);
        } catch (error) {
            console.error("Error cargando servicios:", error);
            setLoading(false);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            await saveServicio(formData);
            alert("¡Servicio guardado correctamente!");
            closeModal();
            cargarLista();
        } catch (error) {
            alert("Error al guardar: " + error.message);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("¿Estás seguro de eliminar/ocultar este servicio?")) {
            try {
                await deleteServicio(id);
                cargarLista();
                alert("Servicio actualizado correctamente.");
            } catch (error) {
                alert("Error al eliminar servicio: " + error.message);
            }
        }
    };

    // Lógica de filtrado por nombre, ID o descripción
    const serviciosFiltrados = servicios.filter(s => 
        (s.nombre && s.nombre.toLowerCase().includes(busqueda.toLowerCase())) ||
        (s.servicios_id && s.servicios_id.toString().includes(busqueda)) ||
        (s.descripcion && s.descripcion.toLowerCase().includes(busqueda.toLowerCase()))
    );

    const openModal = (serv = null) => {
        if (serv) {
            setFormData({
                servicios_id: serv.servicios_id || '',
                nombre: serv.nombre || '',
                descripcion: serv.descripcion || '',
                imagen: serv.imagen || '',
                visibilidad: serv.visibilidad || 'visible'
            });
        } else {
            setFormData({
                servicios_id: '',
                nombre: '',
                descripcion: '',
                imagen: '',
                visibilidad: 'visible'
            });
        }
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    return (
        <section className="main__content">
            <div className="table-container">
                <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap', gap: '10px' }}>
                    <h2>GESTIÓN DE SERVICIOS</h2>

                    {/* BARRA DE BÚSQUEDA */}
                    <div className="search-container" style={{ position: 'relative', minWidth: '280px', flex: '1', maxWidth: '400px' }}>
                        <i className="fa fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }}></i>
                        <input 
                            type="text"
                            className="search-input"
                            placeholder="Buscar por nombre, ID o descripción..."
                            style={{ paddingLeft: '35px', width: '100%', borderRadius: '8px', border: '1px solid #ddd', height: '40px' }}
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                    </div>

                    <button type="button" className="btn-vender-sidebar" onClick={() => openModal()}>
                        <i className="fa fa-plus"></i> Nuevo Servicio
                    </button>
                </div>

                <div className="table-responsive">
                    <table className="novatech-table">                    
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Imagen</th>
                                <th>Nombre del Servicio</th>
                                <th>Descripción</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                        <i className="fas fa-spinner fa-spin me-2"></i> Cargando servicios...
                                    </td>
                                </tr>
                            ) : serviciosFiltrados.length === 0 ? (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                        No se encontraron servicios registrados.
                                    </td>
                                </tr>
                            ) : (
                                serviciosFiltrados.map((s) => (
                                    <tr key={s.servicios_id}>
                                        <td data-label="ID">#{s.servicios_id}</td>
                                        <td data-label="Imagen">
                                            {s.imagen ? (
                                                <img 
                                                    src={s.imagen} 
                                                    alt={s.nombre} 
                                                    style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #ccc' }} 
                                                    onError={(e) => { e.target.style.display = 'none'; }}
                                                />
                                            ) : (
                                                <div style={{ width: '50px', height: '50px', borderRadius: '8px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa' }}>
                                                    <i className="fa-solid fa-image"></i>
                                                </div>
                                            )}
                                        </td>
                                        <td data-label="Nombre" style={{ fontWeight: '600' }}>{s.nombre}</td>
                                        <td data-label="Descripción" style={{ maxWidth: '280px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={s.descripcion}>
                                            {s.descripcion || <span style={{ color: '#999' }}>Sin descripción</span>}
                                        </td>
                                        <td data-label="Estado">
                                            <span style={{
                                                padding: '4px 10px',
                                                borderRadius: '20px',
                                                fontSize: '0.8rem',
                                                fontWeight: '600',
                                                backgroundColor: s.visibilidad === 'oculto' ? '#ffebee' : '#e8f5e9',
                                                color: s.visibilidad === 'oculto' ? '#c62828' : '#2e7d32'
                                            }}>
                                                {s.visibilidad === 'oculto' ? 'Oculto' : 'Visible'}
                                            </span>
                                        </td>
                                        <td data-label="Acciones" className="actions-cell">
                                            <button className="btn-edit" onClick={() => openModal(s)} title="Editar Servicio">
                                                <i className="fa fa-edit"></i> Editar
                                            </button>
                                            <button className="btn-delete" onClick={() => handleDelete(s.servicios_id)} title="Eliminar u Ocultar">
                                                <i className="fa fa-trash"></i> Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {isModalOpen && (
                <div className="modal" style={{ display: 'flex' }}>
                    <div className="modal-content" style={{ maxWidth: '520px', width: '90%' }}>
                        <form onSubmit={handleSave}>
                            <h2>{formData.servicios_id ? "EDITAR SERVICIO" : "NUEVO SERVICIO"}</h2>
                            
                            <div className="form-group">
                                <label>Nombre del Servicio *</label>
                                <input 
                                    type="text" 
                                    value={formData.nombre} 
                                    required 
                                    placeholder="Ej. Desarrollo de Tienda Virtual, Consultoría TI..."
                                    onChange={(e) => setFormData({...formData, nombre: e.target.value})} 
                                />
                            </div>

                            <div className="form-group">
                                <label>URL de la Imagen *</label>
                                <input 
                                    type="url" 
                                    value={formData.imagen} 
                                    required 
                                    placeholder="https://ejemplo.com/imagen.jpg"
                                    onChange={(e) => setFormData({...formData, imagen: e.target.value})} 
                                />
                                {formData.imagen && (
                                    <div style={{ marginTop: '8px', textAlign: 'center' }}>
                                        <img 
                                            src={formData.imagen} 
                                            alt="Vista previa" 
                                            style={{ maxHeight: '90px', borderRadius: '6px', objectFit: 'cover', border: '1px solid #ddd' }}
                                            onError={(e) => { e.target.style.display = 'none'; }}
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Descripción del Servicio</label>
                                <textarea 
                                    rows="4" 
                                    value={formData.descripcion} 
                                    placeholder="Detalles sobre el alcance, tecnologías o beneficios del servicio..."
                                    onChange={(e) => setFormData({...formData, descripcion: e.target.value})}
                                ></textarea>
                            </div>

                            <div className="form-group">
                                <label>Visibilidad en Catálogo</label>
                                <select 
                                    value={formData.visibilidad} 
                                    onChange={(e) => setFormData({...formData, visibilidad: e.target.value})}
                                >
                                    <option value="visible">Visible (Mostrar a clientes)</option>
                                    <option value="oculto">Oculto (Desactivado temporalmente)</option>
                                </select>
                            </div>

                            <div className="actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                                <button type="button" className="btn-cancel" onClick={closeModal}>Cancelar</button>
                                <button type="submit" className="btn-save">
                                    <i className="fa fa-save me-1"></i> Guardar Servicio
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
}

export default DashboardProductos;